import Vue from 'vue'
import VueRouter from 'vue-router'

import BoardList from '../views/EnergyBoard/BoardList.vue'
import BoardDetails from '../views/EnergyBoard/BoardDetails.vue'
import BoardAdd from '../views/EnergyBoard/BoardAdd.vue'
import BoardEdit from '../views/EnergyBoard/BoardEdit.vue'

import AirQualityList from '../views/AirQualityBoard/AirQualityList.vue'
import AirQualityAdd from '../views/AirQualityBoard/AirQualityAdd.vue'
import AirQualityEdit from '../views/AirQualityBoard/AirQualityEdit.vue'

import WaterList from '../views/WaterBoard/WaterList.vue'
import WaterDetails from '../views/WaterBoard/WaterDetails.vue'
import WaterAdd from '../views/WaterBoard/WaterAdd.vue'
import WaterEdit from '../views/WaterBoard/WaterEdit.vue'

import WaterTankList from '../views/WaterTank/WaterTankList.vue'
import WaterTankDetails from '../views/WaterTank/WaterTankDetails.vue'
import WaterTankAdd from '../views/WaterTank/WaterTankAdd.vue'
import WaterTankEdit from '../views/WaterTank/WaterTankEdit.vue'

import SinglePhaseList from '../views/SinglePhase/SinglePhaseList.vue'
import SinglePhaseDetails from '../views/SinglePhase/SinglePhaseDetails.vue'
import SinglePhaseAdd from '../views/SinglePhase/SinglePhaseAdd.vue'
import SinglePhaseEdit from '../views/SinglePhase/SinglePhaseEdit.vue'

import Overview from '../views/Overview/Overview.vue'
import Location from '../views/Location/Location.vue'
import Meter from '../views/Meter/Meter.vue'

import UsageByDbEnergy from '../views/Energy/UsageByDb.vue'
import UsageByDbTotalEnergy from '../views/Energy/UsageByDbTotal.vue'
import UsageByPhaseEnergy from '../views/Energy/UsageByPhase.vue'
import UsageByLocationEnergy from '../views/Energy/UsageByLocation.vue'

import OverviewAirQuality from '../views/AirQuality/Overview.vue'
import AQByLocation from '../views/AirQuality/AQByLocation.vue'

import UsageByLocationWaterFlow from '../views/WaterFlow/UsageByLocation.vue'

import OverviewWaterTank from '../views/WaterLevelTank/Overview.vue'

import ManageAsset from '../views/ManageAsset/ManageAsset.vue'

import SecurityDoor from '../views/SecurityDoor/SecurityDoor.vue'

import C_1A from '../views/BoardChannelDetails/C_1A.vue'
import C_1B from '../views/BoardChannelDetails/C_1B.vue'
import C_1C from '../views/BoardChannelDetails/C_1C.vue'
import C_1D from '../views/BoardChannelDetails/C_1D.vue'
import C_1E from '../views/BoardChannelDetails/C_1E.vue'
import C_1F from '../views/BoardChannelDetails/C_1F.vue'
import C_1G from '../views/BoardChannelDetails/C_1G.vue'
import C_1H from '../views/BoardChannelDetails/C_1H.vue'

import C_2A from '../views/BoardChannelDetails/C_2A.vue'
import C_2B from '../views/BoardChannelDetails/C_2B.vue'
import C_2C from '../views/BoardChannelDetails/C_2C.vue'
import C_2D from '../views/BoardChannelDetails/C_2D.vue'
import C_2E from '../views/BoardChannelDetails/C_2E.vue'
import C_2F from '../views/BoardChannelDetails/C_2F.vue'
import C_2G from '../views/BoardChannelDetails/C_2G.vue'
import C_2H from '../views/BoardChannelDetails/C_2H.vue'

import C_3A from '../views/BoardChannelDetails/C_3A.vue'
import C_3B from '../views/BoardChannelDetails/C_3B.vue'
import C_3C from '../views/BoardChannelDetails/C_3C.vue'
import C_3D from '../views/BoardChannelDetails/C_3D.vue'
import C_3E from '../views/BoardChannelDetails/C_3E.vue'
import C_3F from '../views/BoardChannelDetails/C_3F.vue'
import C_3G from '../views/BoardChannelDetails/C_3G.vue'
import C_3H from '../views/BoardChannelDetails/C_3H.vue'

import C_4A from '../views/BoardChannelDetails/C_4A.vue'
import C_4B from '../views/BoardChannelDetails/C_4B.vue'
import C_4C from '../views/BoardChannelDetails/C_4C.vue'
import C_4D from '../views/BoardChannelDetails/C_4D.vue'
import C_4E from '../views/BoardChannelDetails/C_4E.vue'
import C_4F from '../views/BoardChannelDetails/C_4F.vue'
import C_4G from '../views/BoardChannelDetails/C_4G.vue'
import C_4H from '../views/BoardChannelDetails/C_4H.vue'


Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  board: process.env.BOARD_URL,
  routes:[
    {
      path: '/',
      name: 'Manage Asset',
      component: ManageAsset
    },
    {
      path: '/security-door',
      name: 'Security Door',
      component: SecurityDoor
    },
    {
      path: '/overview',
      name: 'Overview',
      component: Overview
    },
    {
      path: '/board',
      name: 'Board List',
      component: BoardList
    },
    {
      path: '/board/details/:id',
      name: 'Board Details',
      component: BoardDetails
    },
    {
      path: '/board/add',
      name: 'Board Add',
      component: BoardAdd
    },
    {
      path: '/board/edit/:id',
      name: 'Board Edit',
      component: BoardEdit
    },
    {
      path: '/air-quality',
      name: 'Air Quality List',
      component: AirQualityList
    },
    {
      path: '/air-quality/add',
      name: 'Air Quality Add',
      component: AirQualityAdd
    },
    {
      path: '/air-quality/edit/:id',
      name: 'Air Quality Edit',
      component: AirQualityEdit
    },
    {
      path: '/water-board',
      name: 'Water List',
      component: WaterList
    },
    {
      path: '/water-board/details/:id',
      name: 'Water Details',
      component: WaterDetails
    },
    {
      path: '/water-board/add',
      name: 'Water Add',
      component: WaterAdd
    },
    {
      path: '/water-board/edit/:id',
      name: 'Water Edit',
      component: WaterEdit
    },
    {
      path: '/water-tank',
      name: 'Water Tank List',
      component: WaterTankList
    },
    {
      path: '/water-tank/details/:id',
      name: 'Water Tank Details',
      component: WaterTankDetails
    },
    {
      path: '/water-tank/add',
      name: 'Water Tank Add',
      component: WaterTankAdd
    },
    {
      path: '/water-tank/edit/:id',
      name: 'Water Tank Edit',
      component: WaterTankEdit
    },
    {
      path: '/single-phase',
      name: 'Single Phase List',
      component: SinglePhaseList
    },
    {
      path: '/single-phase/details/:id',
      name: 'Single Phase Details',
      component: SinglePhaseDetails
    },
    {
      path: '/single-phase/add',
      name: 'Single Phase Add',
      component: SinglePhaseAdd
    },
    {
      path: '/single-phase/edit/:id',
      name: 'Single Phase Edit',
      component: SinglePhaseEdit
    },
    {
      path: '/location',
      name: 'Location',
      component: Location
    },
    {
      path: '/meter',
      name: 'Meter',
      component: Meter
    },
    {
      path: '/overview-air-quality',
      name: 'Overview Air Quality',
      component: OverviewAirQuality
    },
    {
      path: '/aq-by-location',
      name: 'AQ By Location',
      component: AQByLocation
    },
    {
      path: '/usage-by-db-energy',
      name: 'Usage By Db Energy',
      component: UsageByDbEnergy
    },
    {
      path: '/usage-by-db-total-energy',
      name: 'Usage By Db Total Energy',
      component: UsageByDbTotalEnergy
    },
    {
      path: '/usage-by-location-energy',
      name: 'Usage By Location Energy',
      component: UsageByLocationEnergy
    },
    {
      path: '/usage-by-phase-energy',
      name: 'Usage By Phase Energy',
      component: UsageByPhaseEnergy
    },
    {
      path: '/usage-by-location-water-flow',
      name: 'Usage By Location Water Flow',
      component: UsageByLocationWaterFlow
    },
    {
      path: '/overview-water-tank',
      name: 'Overview Water Tank',
      component: OverviewWaterTank
    },
    {
      path: '/board/C_1A/:id',
      name: 'C_1A',
      component: C_1A
    },
    {
      path: '/board/C_1B/:id',
      name: 'C_1B',
      component: C_1B
    },
    {
      path: '/board/C_1C/:id',
      name: 'C_1C',
      component: C_1C
    },
    {
      path: '/board/C_1D/:id',
      name: 'C_1D',
      component: C_1D
    },
    {
      path: '/board/C_1E/:id',
      name: 'C_1E',
      component: C_1E
    },
    {
      path: '/board/C_1F/:id',
      name: 'C_1F',
      component: C_1F
    },
    {
      path: '/board/C_1G/:id',
      name: 'C_1G',
      component: C_1G
    },
    {
      path: '/board/C_1H/:id',
      name: 'C_1H',
      component: C_1H
    },
    {
      path: '/board/C_2A/:id',
      name: 'C_2A',
      component: C_2A
    },
    {
      path: '/board/C_2B/:id',
      name: 'C_2B',
      component: C_2B
    },
    {
      path: '/board/C_2C/:id',
      name: 'C_2C',
      component: C_2C
    },
    {
      path: '/board/C_2D/:id',
      name: 'C_2D',
      component: C_2D
    },
    {
      path: '/board/C_2E/:id',
      name: 'C_2E',
      component: C_2E
    },
    {
      path: '/board/C_2F/:id',
      name: 'C_2F',
      component: C_2F
    },
    {
      path: '/board/C_2G/:id',
      name: 'C_2G',
      component: C_2G
    },
    {
      path: '/board/C_2H/:id',
      name: 'C_2H',
      component: C_2H
    },
    {
      path: '/board/C_3A/:id',
      name: 'C_3A',
      component: C_3A
    },
    {
      path: '/board/C_3B/:id',
      name: 'C_3B',
      component: C_3B
    },
    {
      path: '/board/C_3C/:id',
      name: 'C_3C',
      component: C_3C
    },
    {
      path: '/board/C_3D/:id',
      name: 'C_3D',
      component: C_3D
    },
    {
      path: '/board/C_3E/:id',
      name: 'C_3E',
      component: C_3E
    },
    {
      path: '/board/C_3F/:id',
      name: 'C_3F',
      component: C_3F
    },
    {
      path: '/board/C_3G/:id',
      name: 'C_3G',
      component: C_3G
    },
    {
      path: '/board/C_3H/:id',
      name: 'C_3H',
      component: C_3H
    },
    {
      path: '/board/C_4A/:id',
      name: 'C_4A',
      component: C_4A
    },
    {
      path: '/board/C_4B/:id',
      name: 'C_4B',
      component: C_4B
    },
    {
      path: '/board/C_4C/:id',
      name: 'C_4C',
      component: C_4C
    },
    {
      path: '/board/C_4D/:id',
      name: 'C_4D',
      component: C_4D
    },
    {
      path: '/board/C_4E/:id',
      name: 'C_4E',
      component: C_4E
    },
    {
      path: '/board/C_4F/:id',
      name: 'C_4F',
      component: C_4F
    },
    {
      path: '/board/C_4G/:id',
      name: 'C_4G',
      component: C_4G
    },
    {
      path: '/board/C_4H/:id',
      name: 'C_4H',
      component: C_4H
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (router.app.$keycloak.authenticated && router.app.$keycloak.hasRealmRole('admin')) {
      next()
    } else {
      if (router.app.$keycloak.authenticated)
        router.app.$keycloak.logoutFn()
      else {
        const loginUrl = router.app.$keycloak.createLoginUrl()
        window.location.replace(loginUrl)
      }
    }
  } else {
    next()
  }
})

export default router
